import { useCallback } from 'react';
import {
  useTripStore,
  useSetTripFilters,
  useSetListMode,
  useResetDaySelection,
  useSetLastAddedExperienceId,
  useSetCompareWithVersion,
  useSetFocusDay,
  useSetMapState,
} from '@koob/trip-designer';

// Replaces the deleted trip designer context provider's `resetContext`
// (US-051): clears
// trip designer data — localStorage and the shared store — so the next trip
// starts clean. Not store data itself, so it has no selector hook equivalent;
// this stays a plain app hook.
export const useResetTripDesigner = () => {
  const resetTrip = useTripStore(state => state.resetTrip);
  const setTripFilters = useSetTripFilters();
  const setListMode = useSetListMode();
  const resetDaySelection = useResetDaySelection();
  const setLastAddedExperienceId = useSetLastAddedExperienceId();
  const setCompareWithVersion = useSetCompareWithVersion();
  const setFocusDay = useSetFocusDay();
  const setMapState = useSetMapState();

  return useCallback(() => {
    localStorage.removeItem('tripFiltersCache');
    localStorage.removeItem('tripDataCache');
    localStorage.removeItem('trip-designer-storage');

    setTripFilters(null);
    // Back to the default panel — leaving 'chat' active dropped the next
    // trip straight into the DMC chat, and a leftover hotel toggle opened
    // it on the hotel search.
    setListMode('map');
    resetDaySelection();
    setLastAddedExperienceId(null);
    setCompareWithVersion(null);
    setFocusDay(null);
    setMapState({ center: null, zoom: null });

    resetTrip();
  }, [
    resetTrip,
    setTripFilters,
    setListMode,
    resetDaySelection,
    setLastAddedExperienceId,
    setCompareWithVersion,
    setFocusDay,
    setMapState,
  ]);
};
